import {
  createNumFormatterWithFallback,
  createEuroCurrencyFormatterWithFallback
} from '@/common'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function useI18n() {
  const { t, i18n } = useTranslation()
  const { changeLanguage, language: currentLanguage } = i18n

  const numberFormatter = useMemo(
    () =>
      createNumFormatterWithFallback(currentLanguage, {
        maximumFractionDigits: 4
      }),
    [currentLanguage]
  )

  const numberFormatter2Decimals = useMemo(
    () =>
      createNumFormatterWithFallback(currentLanguage, {
        maximumFractionDigits: 2
      }),
    [currentLanguage]
  )

  const numberFormatter3Decimals = useMemo(
    () =>
      createNumFormatterWithFallback(currentLanguage, {
        maximumFractionDigits: 3
      }),
    [currentLanguage]
  )

  const numberFormatter3DecimalsGB = useMemo(
    () =>
      createNumFormatterWithFallback('en-GB', {
        maximumFractionDigits: 3
      }),
    []
  )

  const dateFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat(currentLanguage, {
        month: 'numeric',
        year: 'numeric',
        day: 'numeric'
      }).format,
    [currentLanguage]
  )

  const dateFormatterGb = useMemo(
    () =>
      new Intl.DateTimeFormat('en-GB', {
        month: 'numeric',
        year: 'numeric',
        day: 'numeric'
      }).format,
    []
  )

  const dateLongFormatterGB = useMemo(
    () =>
      new Intl.DateTimeFormat('en-GB', {
        month: 'long',
        year: 'numeric',
        day: 'numeric'
      }).format,
    []
  )

  const dateLongFormatterMonthYear = useMemo(
    () =>
      new Intl.DateTimeFormat(currentLanguage, {
        month: 'short',
        year: '2-digit'
      }).format,
    [currentLanguage]
  )

  const dateLongFormatterMonth = useMemo(
    () =>
      new Intl.DateTimeFormat(currentLanguage, {
        month: 'short'
      }).format,
    [currentLanguage]
  )

  const dateFormatterMonthYear = useMemo(
    () =>
      new Intl.DateTimeFormat(currentLanguage, {
        month: 'numeric',
        year: 'numeric'
      }).format,
    [currentLanguage]
  )

  const dateTimeFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat(currentLanguage, {
        month: 'long',
        year: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }).format,
    [currentLanguage]
  )

  const currencyFormatter = useMemo(
    () => createEuroCurrencyFormatterWithFallback(currentLanguage, { maximumFractionDigits: 0 }),
    [currentLanguage]
  )

  const currencyFormatter2Decimals = useMemo(
    () => createEuroCurrencyFormatterWithFallback(currentLanguage, { maximumFractionDigits: 2 }),
    [currentLanguage]
  )

  const numberFormatterNoDecimals = useMemo(
    () => createNumFormatterWithFallback(currentLanguage, { maximumFractionDigits: 0 }),
    [currentLanguage]
  )

  const numberFormatter4Decimals = useMemo(
    () =>
      createNumFormatterWithFallback(currentLanguage, {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
      }),
    [currentLanguage]
  )

  return {
    t,
    currentLanguage,
    handleChangeLanguage: changeLanguage,
    numberFormatter,
    numberFormatter2Decimals,
    numberFormatter3Decimals,
    numberFormatter4Decimals,
    dateFormatter,
    dateFormatterMonthYear,
    currencyFormatter,
    currencyFormatter2Decimals,
    dateTimeFormatter,
    numberFormatterNoDecimals,
    dateFormatterGb,
    dateLongFormatterGB,
    numberFormatter3DecimalsGB,
    dateLongFormatterMonthYear,
    dateLongFormatterMonth
  }
}
